import { render, staticRenderFns } from "./CreateVenue.vue?vue&type=template&id=3fb5f4fe&scoped=true&"
import script from "./CreateVenue.vue?vue&type=script&lang=js&"
export * from "./CreateVenue.vue?vue&type=script&lang=js&"
import style0 from "./CreateVenue.vue?vue&type=style&index=0&id=3fb5f4fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb5f4fe",
  null
  
)

export default component.exports